module.exports = __WEBPACK_EXTERNAL_MODULE_adaptive_expressions__;